import { Breadcrumb } from 'antd';
import { Link } from 'gatsby';
import propType from 'prop-types';
import React from 'react';

import Chevron from '../../assets/svgs/chevron.svg';
import HomeIcon from '../../assets/svgs/home.svg';
import stripHtmlTag from '../../utils/stripHtmlTag';

const BravoBreadcrumb = ({ breadcrumb, ...props }) => {
  return (
    <Breadcrumb
      separator={<Chevron />}
      {...props}
      className={`breadcrumb ${props.className}`}
    >
      {breadcrumb.map((route, index) => {
        const first = index === 0;
        const last = index === breadcrumb.length - 1;
        const title = stripHtmlTag(route.text);

        return last ? (
          <Breadcrumb.Item key={title}>
            <span key={title} className="breadcrumb__item">
              {title}
            </span>
          </Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item key={title}>
            <Link
              key={title}
              className="breadcrumb__item internal-link"
              to={route.url}
            >
              {first ? (
                <HomeIcon
                  style={{ display: 'inline', verticalAlign: 'initial' }}
                />
              ) : (
                title
              )}
            </Link>
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};
BravoBreadcrumb.defaultProps = {
  className: ''
};
BravoBreadcrumb.propTypes = {
  breadcrumb: propType.arrayOf(
    propType.shape({
      text: propType.string.isRequired,
      url: propType.string.isRequired
    })
  ).isRequired,
  className: propType.string
};

export default BravoBreadcrumb;
